import { createFileRoute } from "@tanstack/react-router";
import { RouteGuard } from "@/components/RouteGuard";
import { AssessmentSettingsManagement } from "@/lib/lazyPages";

export const Route = createFileRoute("/admin/assessment-settings")({
  component: () => (
    <RouteGuard access={{ kind: "admin" }}>
      <AssessmentSettingsManagement />
    </RouteGuard>
  ),
});
